import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, Observable } from 'rxjs';
import { failStatus, GenericRequest, successStatus } from '@core/models/request-status.model';
import { environment } from '@environments/environment';
import { TermsModel } from '@b2b/components/terms/utilities/terms.model';

@Injectable({
  providedIn: 'root',
})
export class TermsService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
  ) {}

  getContent(): Observable<GenericRequest<TermsModel>> {
    const url = `${environment.apiService}/terms/current`;

    return this.http.get<TermsModel>(url).pipe(
      map(terms => {
        return { data: terms, ...successStatus };
      }),
      catchError(() => {
        return this.translateService.get('generic.requestError').pipe(
          map(message => ({
            ...failStatus,
            message,
          })),
        );
      }),
    );
  }
}
